import React, { Component } from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import {Col,Form,Button,Modal} from "react-bootstrap";

import LeftSideNavigation from "../../../vendorDashboardComponents/navigationSection/LeftSideNavigation";
import { HomeReusableButton } from "../../superAdminReusable/superAdminHomeButton/HomeReusableButton";
import HomeReusableTopBarNavigation from "../../superAdminReusable/superAdminHomeButton/HomeReusableTopBarNavigation";
import ReportsDashboardSuperAdmin from "./ReportsDashboardSuperAdmin";
// import ReportsDashboardTwo from "./reportsDashboard/ReportsDashboardTwo";
// import OffersReports from "./offerReports/OffersReports";
import EventsReports from "../../../vendorDashboardComponents/reportsDashboard/eventReports/EventsReports";
import SeatingReportsDashboard from "../../../vendorDashboardComponents/reportsDashboard/seatingReports/SeatingReportsDashboard";

// import { Col } from "react-bootstrap";
import { TextField } from "@material-ui/core";
import SVG from "react-inlinesvg";
import Media from "react-media";
import moment from "moment";
import { BasicDateRangePicker } from "../../../vendorDashboardComponents/manageHoursOperation/DatePickerRange";
import { TopTextReusableComponent } from "../../../vendorOnboradingComponents/reusableOnboardingComponent/TopTextReusable/TopTextReusableComponent";
// import ReportsDashboardOffers from "../../../vendorDashboardComponents/reportsDashboard/reportsDashboard/ReportsDashboardOffers";
// import ReportsDashboardEvents from "../../../vendorDashboardComponents/reportsDashboard/reportsDashboard/ReportsDashboardEvents";
// import ReportsDashboardOrders from "../../../vendorDashboardComponents/reportsDashboard/reportsDashboard/ReportsDashboardOrders";
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import InboxIcon from '@material-ui/icons/MoveToInbox';
import DraftsIcon from '@material-ui/icons/Drafts';
import SendIcon from '@material-ui/icons/Send';
import { withStyles } from '@material-ui/core/styles';

const StyledMenu = withStyles({
  paper: {
    border: '1px solid #d3d4d5',
  },
})((props) => (
  <Menu
    elevation={0}
    getContentAnchorEl={null}
    anchorOrigin={{
      vertical: 'bottom',
      horizontal: 'center',
    }}
    transformOrigin={{
      vertical: 'top',
      horizontal: 'center',
    }}
    {...props}
  />
));

const StyledMenuItem = withStyles((theme) => ({
  root: {
    '&:focus': {
      backgroundColor: theme.palette.primary.main,
      '& .MuiListItemIcon-root, & .MuiListItemText-primary': {
        color: theme.palette.common.white,
      },
    },
  },
}))(MenuItem);

class SeatingAnalytics extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      openPax: false,
      showStatus: "All",
      showPax: "All",
      displayTab: "reportsOne",
      rightSideTab: "reportsOne",
      dateFilter: moment(new Date()).format("YYYY-MM-DD"),
      dateTo: moment(new Date()).format("YYYY-MM-DD"),
      dateFrom: moment(new Date()).format("YYYY-MM-DD"),
      reportType:"monthly",
      showEditRole: false,
      modelStep: TopTextReusableComponent,
      anchorEl:null,
      customRange: false,
    };
  }

  handleCustom = () => {
    this.setState({customRange: true})
  }

  handleCloseCustom = () => {
    this.setState({customRange: false})
  }

  handleClick = (event) => {
    this.setState({anchorEl :event.currentTarget});
  };

  handleClose = () => {
    this.setState({anchorEl :null});
  };

  handleShowEditRole = () => this.setState({showEditRole: true});
  handleCloseEditRole = () => this.setState({showEditRole: false});

  changeStep = (e) => {
    e.preventDefault();
    this.setState({modelStep: false});
    // setShowEditRole(false);
  };

  /****************************************
   * @DESC Ope Modal
   ***************************************/
  onOpenModal = () => {
    this.setState({ open: true });
  };
  onCloseModal = () => {
    this.setState({ open: false });
  };
  onOpenModalPax = () => {
    this.setState({ openPax: true });
  };
  onCloseModalPax = () => {
    this.setState({ openPax: false });
  };

  /****************************************
    @DESC Big Button Show Status Handler
   ***************************************/
  bigButtonShowStatusHandler = (e, type) => {
    e.preventDefault();
    this.setState({
      showStatus: type,
      open: false,
    });
  };

  bigButtonShowPaxHandler = (e, type) => {
    e.preventDefault();
    this.setState({
      showPax: type,
      openPax: false,
    });
  };

  /****************************************
   * @DESC Button Show Status Handler
   ***************************************/
  buttonClickHandler = (e, type) => {
    e.preventDefault();
    this.setState({
      displayTab: type,
      rightSideTab: type,
    });
  };

  reportTypeHandler = (e, type) => {
    e.preventDefault();
    this.setState({
      reportType: type,
    });
  };

  changeDate = (e) => this.setState({ dateFilter: e.target.value });
  onFromDateChange = (e) => this.setState({ dateFrom: e.target.value });
  onToDateChange = (e) => this.setState({ dateTo: e.target.value });

  render() {
    // console.log(this.state);
    const { dateFilter } = this.state;
    return (
      <React.Fragment>
        <Container fluid>
          <Row>
            <Media query="(min-width: 992px)">
              <div className="left-side-panel">
              <LeftSideNavigation displayLink={1} />
              </div>
            </Media>
            {/* <div className="top-panel">
              <TopNavigationBarMobile
                displayLeft="backButton"
                backLink="/seatingdashboard"
                headText="Seating Report"
              />
            </div> */}
            <div className="right-side-panel">
            <HomeReusableTopBarNavigation displayText="super admin home" />
              <Row className="align-items-center mb-5">
                <Col md={6} className="f24_700_HelveticaNeue">
                Seating Analytics
                </Col>
                {/* <Col md={6} className="text-right"> */}
                {/* {this.state.displayTab === "reportsOne" ||
                  this.state.rightSideTab === "reportsTwo" ? ( */}
                {/* <TextField
                    type="date"
                    variant="outlined"
                    value={dateFilter}
                    onChange={this.changeDate}
                  /> */}
                {/* ) : null} */}
                {/* </Col> */}
              </Row>
              <Row>
                <div className="col-lg-4 d-flex flex-wrap">
                </div>
                  

                <div className="col-lg-8 d-flex justify-content-end align-items-center">
                  {/* {this.state.displayTab === "seatingDdashboard" ? ( */}
                  {/* // this.state.displayTab === "offers" || */}
                  {/* // this.state.displayTab === "events" */}
                  <div className="w-100 row justify-content-end">
                    <Col md={6} lg={6}>
                      <div className="f12-500 mb-1">Starts Date</div>
                      <TextField
                        type="date"
                        className="w-100"
                        variant="outlined"
                        // onChange={this.onFromDateChange}
                        onClick={this.handleShowEditRole}
                      />
                    </Col>
                    <Col md={6} lg={6}>
                      <div className="f12-500 mb-1">Ends Date</div>
                      <TextField
                        type="date"
                        className="w-100"
                        variant="outlined"
                        // onChange={this.onToDateChange}
                        onClick={this.handleShowEditRole}
                      />
                    </Col>
                    {/* <div className="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6 d-flex align-items-end">
                        <div className="report-seating-dashboard-button">
                          <div className="d-flex">
                            <div className="seating-dashboard-main">
                              <div>
                                <Image
                                  fluid
                                  src={require("../../../assets/images/ActionImages/calendar.png")}
                                  alt="Previous Date"
                                  title="Previous Date"
                                />
                                <p>From</p>
                              </div>
                              <div className="date-display-box">
                                <h5>
                                  09 <span>Mar 20 Monday</span>
                                </h5>
                              </div>
                            </div>
                            <div className="seating-dashboard-main">
                              <div>
                                <Image
                                  fluid
                                  src={require("../../../assets/images/ActionImages/calendar.png")}
                                  alt="Previous Date"
                                  title="Previous Date"
                                />
                                <p>From</p>
                              </div>
                              <div className="date-display-box">
                                <h5>
                                  09 <span>Mar 20 Monday</span>
                                </h5>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div> */}
                    {/* <div className="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6 d-flex justify-content-between">
                        <div className="col">
                          <SeatingStatus
                            status={this.state.showStatus}
                            onOpenModal={this.onOpenModal}
                            onCloseModal={this.onCloseModal}
                            open={this.state.open}
                            seatingStatus={this.state.showStatus}
                            onClickAll={(e) =>
                              this.bigButtonShowStatusHandler(e, "All")
                            }
                            onClickSeated={(e) =>
                              this.bigButtonShowStatusHandler(e, "Seated")
                            }
                            onClickNonSeated={(e) =>
                              this.bigButtonShowStatusHandler(e, "Nonseated")
                            }
                          />
                        </div>
                        <div className="col">
                          <TableSizePopup
                            showPax={this.state.showPax}
                            onOpenModal={this.onOpenModalPax}
                            open={this.state.openPax}
                            onCloseModal={this.onCloseModalPax}
                            table_size={this.state.showPax}
                            onClickAll={(e) =>
                              this.bigButtonShowPaxHandler(e, "All")
                            }
                            onClickTwo={(e) =>
                              this.bigButtonShowPaxHandler(e, "2")
                            }
                            onClickFour={(e) =>
                              this.bigButtonShowPaxHandler(e, "4")
                            }
                            onClickSix={(e) =>
                              this.bigButtonShowPaxHandler(e, "6")
                            }
                            onClickEight={(e) =>
                              this.bigButtonShowPaxHandler(e, "8")
                            }
                            graterThanEight={(e) =>
                              this.bigButtonShowPaxHandler(e, "8>")
                            }
                          />
                        </div>
                      </div> */}
                  </div>
                  {/* // ) : null} */}
                  {/* {this.state.displayTab === "reportsOne" ||
                  this.state.displayTab === "reportsTwo" ? (
                    <React.Fragment>
                      <div
                        className={
                          this.state.displayTab === "reportsOne"
                            ? "f18-500 cursor text-red"
                            : "f18-500 cursor"
                        }
                        onClick={(e) =>
                          this.buttonClickHandler(e, "reportsOne")
                        }
                      >
                        Seating Report 1
                      </div>
                      <div className="borderRideSide"></div>
                      <div
                        className={
                          this.state.displayTab === "reportsTwo"
                            ? "f18-500 cursor text-red"
                            : "f18-500 cursor"
                        }
                        onClick={(e) =>
                          this.buttonClickHandler(e, "reportsTwo")
                        }
                      >
                        Seating Report 2
                      </div>
                    </React.Fragment>
                  ) : null}
                  {this.state.displayTab === "reportsoffersOne" ||
                  this.state.displayTab === "reportsoffersTwo" ? (
                    <React.Fragment>
                      <div
                        className={
                          this.state.displayTab === "reportsoffersOne"
                            ? "f18-500 cursor text-red"
                            : "f18-500 cursor"
                        }
                        onClick={(e) =>
                          this.buttonClickHandler(e, "reportsoffersOne")
                        }
                      >
                        Seating Report 1
                      </div>
                      <div className="borderRideSide"></div>
                      <div
                        className={
                          this.state.displayTab === "reportsoffersTwo"
                            ? "f18-500 cursor text-red"
                            : "f18-500 cursor"
                        }
                        onClick={(e) =>
                          this.buttonClickHandler(e, "reportsoffersTwo")
                        }
                      >
                        Seating Report 2
                      </div>
                    </React.Fragment>
                  ) : null}
                  {this.state.displayTab === "events" ||
                  this.state.displayTab === "eventstwo" ? (
                    <React.Fragment>
                      <div
                        className={
                          this.state.displayTab === "events"
                            ? "f18-500 cursor text-red"
                            : "f18-500 cursor"
                        }
                        onClick={(e) => this.buttonClickHandler(e, "events")}
                      >
                        Event Report 1
                      </div>
                      <div className="borderRideSide"></div>
                      <div
                        className={
                          this.state.displayTab === "eventstwo"
                            ? "f18-500 cursor text-red"
                            : "f18-500 cursor"
                        }
                        onClick={(e) => this.buttonClickHandler(e, "eventstwo")}
                      >
                        Event Report 2
                      </div>
                    </React.Fragment>
                  ) : null} */}
                  <div
                    className={`f18-500 cursor ml-3 mr-3 mt-3`}
                    aria-controls="customized-menu"
                    aria-haspopup="true"
                    variant="contained"
                    color="primary"
                    onClick={this.handleClick}
                  >
                    <TextField
                        type="date"
                        className="w-100"
                        variant="outlined"
                        // onChange={this.onToDateChange}
                        // onClick={this.handleShowEditRole}
                      />
                  </div>
                  <StyledMenu
                    id="customized-menu"
                    anchorEl={this.state.anchorEl}
                    keepMounted
                    open={Boolean(this.state.anchorEl)}
                    onClose={this.handleClose}
                  >
                    <StyledMenuItem>
                      <ListItemText primary="Today" />
                    </StyledMenuItem>
                    <StyledMenuItem>
                      <ListItemText primary="Yesderday" />
                    </StyledMenuItem>
                    <StyledMenuItem>
                      <ListItemText primary="Last 7 Days" />
                    </StyledMenuItem>
                    <StyledMenuItem>
                      <ListItemText primary="Last 30 Days" />
                    </StyledMenuItem>
                    <StyledMenuItem>
                      <ListItemText primary="This Month" />
                    </StyledMenuItem>
                    <StyledMenuItem>
                      <ListItemText primary="Last Month" />
                    </StyledMenuItem>
                    <StyledMenuItem>
                      <ListItemText primary="Custom Range" onClick={this.handleCustom} />
                    </StyledMenuItem>
                  </StyledMenu>

                </div>
              </Row>
              <hr />
              <div>
                {this.state.displayTab === "reportsOne" ? (
                  <div className="w-100 bottom-side-panel-reports">
                    <ReportsDashboardSuperAdmin
                      dateFilter={dateFilter}
                      onClick={(e) =>
                        this.buttonClickHandler(e, "seatingDdashboard")
                      }
                      dateTo={this.state.dateTo}
                      dateFrom={this.state.dateFrom}
                      onFromDateChange={this.onFromDateChange}
                      onToDateChange={this.onToDateChange}
                      onDateChange={this.changeDate}
                      reportType={this.state.reportType}
                    />
                  </div>
                ) : null}
                
              </div>
            </div>
            {/* <Media query="(max-width: 991px)">
              <div className="bottom-panel">
                <BottomNavigationMobile />
              </div>
            </Media> */}
          </Row>
        </Container>
      <Modal
        show={this.state.showEditRole}
        size="lg"
        onHide={this.handleCloseEditRole}
        centered
      >
        <Modal.Header className="px-4 border-0" closeButton>
          {this.state.modelStep && (
            <div>
              <Modal.Title className="f20-700 pb-2">
                Copy time to another day
              </Modal.Title>
            </div>
          )}
        </Modal.Header>
        <Modal.Body
          className="px-4"
          style={{ minHeight: this.state.modelStep && "500px" }}
        >
          {this.state.modelStep ? (
            <div>
              <div className="d-flex">
                <div className="f12-500">Starts from</div>
                <div className="f12-500" style={{ marginLeft: "187px" }}>
                  Ends at
                </div>
              </div>
              <BasicDateRangePicker />
            </div>
            // <Form>
            //   <div className="f14-400 mb-4">
            //     Please select the date to copy the timing
            //   </div>

            //   <div className="d-flex align-items-center py-4">
            //     <Button
            //       variant="outline-secondary"
            //       className="btn150px btn-lg mr-4 px-5"
            //       onClick={this.handleCloseEditRole}
            //     >
            //       Cancel
            //     </Button>
            //     <Button
            //       variant="danger"
            //       className="btn150px btn-lg px-5"
            //       onClick={this.changeStep}
            //     >
            //       Choose
            //     </Button>
            //   </div>
            // </Form>
          
          ): null}
        </Modal.Body>
        
          <></>
        
          <Modal.Footer>
            <div
              className="d-flex align-items-center py-4"
              style={{
                justifyContent: "flex-end",
              }}
            >
              <Button
                variant="outline-secondary"
                className="btn-md mr-4 px-5"
                onClick={this.handleCloseEditRole}
              >
                CANCEL
              </Button>
              <Button variant="danger" className="btn-md px-5">
                OK
              </Button>
            </div>
          </Modal.Footer>
       
      </Modal>
      <Modal
        show={this.state.customRange}
        size="lg"
        onHide={this.handleCloseCustom}
        centered
      >
        {/* <Modal.Header className="px-4 border-0" closeButton>
          {this.state.modelStep && (
            <div>
              <Modal.Title className="f20-700 pb-2">
                Copy time to another day
              </Modal.Title>
            </div>
          )}
        </Modal.Header> */}
        <Modal.Body
          className="px-4"
          style={{ minHeight: true && "500px" }}
        >
          <div className="row">
            <div className="col-4">
              <div>Today</div>
              <div>Yesterday</div>
              <div>Last 7 Days</div>
              <div>Last 30 Days</div>
              <div>This Month</div>
              <div>Last Month</div>
              <div>Custom Range</div>
            </div>
            <div className="col-8">
              <div>
                <div className="d-flex">
                  <div className="f12-500">Starts from</div>
                  <div className="f12-500" style={{ marginLeft: "187px" }}>
                    Ends at
                  </div>
                </div>
                <BasicDateRangePicker />
              </div>
            </div>
          </div>
            
            
        </Modal.Body>
        
          <></>
        
          <Modal.Footer>
            <div
              className="d-flex align-items-center py-4"
              style={{
                justifyContent: "flex-end",
              }}
            >
              <Button
                variant="outline-secondary"
                className="btn-md mr-4 px-5"
                onClick={this.handleCloseCustom}
              >
                CANCEL
              </Button>
              <Button variant="danger" className="btn-md px-5">
                OK
              </Button>
            </div>
          </Modal.Footer>
       
      </Modal>
      </React.Fragment>
    );
  }
}

export default SeatingAnalytics;
